<template>
  <div v-if="selectedCompany">
    <table class="table is-fullwidth is-striped is-hoverable">
      <thead>
        <tr>
          <th>ID</th>
          <th>Due Date</th>
          <th>Amount</th>
          <th>Status</th>
          <th>Contract ID</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="invoices.length > 0">
        <tr v-for="(invoice, i) in invoices" :key="i">
          <td>
            <a class="entity-link" href="#" @click="editInvoice(invoice)"
              >{{ invoice.id }}
              <span class="icon is-small edit-icon">
                <i class="fas fa-edit"></i>
              </span>
            </a>
          </td>
          <td>
            {{ formatDate(invoice.due_date, { showRelative: false }) }}
          </td>
          <td>{{ invoice.amount }} {{ invoice.currency }}</td>
          <td>
            <span
              class="tag"
              :class="invoice.is_paid ? 'is-success' : 'is-danger'"
              >{{ invoice.is_paid ? "Paid" : "Unpaid" }}</span
            >
          </td>
          <td>
            {{ invoice.contract_id }}
          </td>
          <td>
            <button
              class="button is-success is-small"
              @click="openPaymentModalForInvoice(invoice)"
            >
              <span class="icon">
                <i class="fas fa-money-bill"></i>
              </span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { formatDate } from "@/utils/date_converter";
import { httpInstance as http } from "@/plugins/http";

export default {
  name: "CompanyInvoicesTab",
  components: {},
  props: {
    companyData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      invoices: [],
    };
  },
  computed: {
    ...mapState(["selectedCompany"]),
    company() {
      return this.companyData || this.selectedCompany;
    },
  },
  methods: {
    ...mapActions([
      "openPaymentModal",
      // "openEditContractModal",
      "openEditInvoiceModal",
    ]),
    formatDate,
    getInvoices() {
      if (!this.company || !this.company.id) return;
      http
        .get(`invoices?page=1&size=20&company_id=${this.company.id}`)
        .then((response) => {
          this.invoices = response.data.data;
        });
    },
    editInvoice(invoice) {
      this.openEditInvoiceModal(invoice);
    },
    // editContract(contract) {
    //   this.openEditContractModal(contract);
    // },
    openPaymentModalForInvoice(invoice) {
      this.openPaymentModal({
        invoice_id: invoice.id,
        amount: invoice.amount,
        description: "",
      });
    },
  },
  mounted() {
    if (this.company) {
      this.getInvoices();
    }

    // Listen for payment/invoice events to refresh invoices
    this.$root.$on("payment-created", this.getInvoices);
    this.$root.$on("invoice-updated", this.getInvoices);
    this.$root.$on("invoice-created", this.getInvoices);
  },
  beforeDestroy() {
    // Clean up event listeners
    this.$root.$off("payment-created", this.getInvoices);
    this.$root.$off("invoice-updated", this.getInvoices);
    this.$root.$off("invoice-created", this.getInvoices);
  },
};
</script>

<style></style>
